import { render } from "./RichMedia.vue?vue&type=template&id=f2541624"
import script from "./RichMedia.vue?vue&type=script&lang=js"
export * from "./RichMedia.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__